const Search = {
  state: {
    timer: "",
    paramsObj: {},
    isInitDeter: false,
  },
  apiObj: null,
  paramsUtilObj: null,

  suppressInitialProcess: function () {
    Search.state.isInitDeter = true;
  },

  init: function () {
    Search.resetDisplay();
    Search.paramsUtilObj = new ParamsUtil();
    Search.apiObj = new ZetaItemApi();
    Search.setApiDefaultParams();
    // collection.handleが取得できる場合はセット
    if(typeof COLLECTION_HANDLE != "undefined"){
      Search.apiObj.collectionname = COLLECTION_HANDLE;
    }    
    if (Search.state.isInitDeter) return;
    (async function () {
      await Search.apiRequest();
    })();
  },

  deleteParams: function (key) {
    delete Search.state.paramsObj[key];
  },

  setKeyword: function (keyword) {
    const paramkey = "q";
    Search.paramsUtilObj.deleteInsertParam(paramkey, keyword);
    Search.apiObj.deleteInsertParam(paramkey, keyword);
  },

  setApiDefaultParams: function () {
    Search.apiObj.initializeParams();
    Search.apiObj.itemLimit = 0;
    Search.apiObj.deleteInsertParam(
      $("input[name=availability]").data("apikey"),
      $("input[name=availability]:checked").data("apivalue")
    );

    Search.paramsUtilObj.initializeParams();
    Search.paramsUtilObj.deleteInsertParam(
      $("input[name=availability]").data("param"),
      $("input[name=availability]:checked").val()
    );
  },

  querySearch: function () {
    if ($(".js-priceMax").val() != "" && $(".js-priceMin").val() != "") {
      if (Number($(".js-priceMax").val()) <= Number($(".js-priceMin").val())) {
        $(".error-message--price").removeClass("hidden");
        return;
      }
    }
    $(".error-message--price").addClass("hidden");

    const queryStrings = Search.paramsUtilObj.makeQueryStrings();
    let url = "/search";
    if (queryStrings != "") {
      url += `?${queryStrings}`;
    }
    window.location.href = url;
  },

  resetDisplay: function () {
    const resetSelectLabel = () => {
      $(".js-radioAndCheckbox").each(function () {
        $(this).find("input").prop("checked", false);
        const $parent = Search.getSelectorParent($(this));
        Search.setSelectName($parent);
      });
    };

    const resetAvailability = () => {
      $('[data-param="filter.v.availability"]:last').prop("checked", true);
    };

    const resetCategory = () => {
      $("input[name=category]").val("");
      $("input[name=category]").attr("data-apivalue", "");
      $("input[name=subcategory]").val("");
      $("input[name=subcategory]").attr("data-apivalue", "");
      $("#category-list-pc [name=category-pc]").val("");
      $("#category-list-pc [name=subcategory-pc]").val("");
      $("#category-list-pc .sub-category-list").hide();
      Search.setSelectName($("#category-list-sp"));
    };

    const resetPrice = () => {
      $(".js-priceMin").val("");
      $(".js-priceMax").val("");
    };

    const resetKeyword = () => {
      $('[data-param="q"]').val("");
    };

    resetSelectLabel();
    resetAvailability();
    resetCategory();
    resetKeyword();
    resetPrice();
  },

  resetFormSearch: function () {
    Search.resetDisplay();
    (async function () {
      Search.setApiDefaultParams();
      await Search.apiRequest();
    })();
  },

  setSelectName: function ($this, selectedtext = "") {
    let text = selectedtext;
    if (!text) text = "指定なし";
    $this.find(".js-select-name").text(text);
  },

  getSelectorParent: function ($this) {
    return $this.closest(".js-select-item");
  },

  getSearchContentFilterParent: function ($this) {
    return $this.closest("#search-where");
  },

  realTimeCounter: function (hitCount) {
    let speed = 1;
    let oldCnt = parseInt($("#hit-count").text());
    let addCnt = oldCnt;
    let nowCnt = parseInt(hitCount);
    let valRange = 100;

    if (Search.state.timer != "") {
      clearInterval(Search.state.timer);
    }

    if (oldCnt < nowCnt) {
      Search.state.timer = setInterval(function () {
        if (addCnt <= nowCnt) {
          $("#hit-count").text(addCnt);
          addCnt = parseInt(addCnt) + valRange;
        } else {
          $("#hit-count").text(nowCnt);
          clearInterval(Search.state.timer);
        }
      }, speed);
    } else {
      Search.state.timer = setInterval(function () {
        if (nowCnt <= addCnt) {
          $("#hit-count").text(addCnt);
          addCnt = parseInt(addCnt) - valRange;
        } else {
          $("#hit-count").text(nowCnt);
          clearInterval(Search.state.timer);
        }
      }, speed);
    }
  },

  apiRequest: _debounce(async function () {
    (async function () {
      await Search.apiObj.request();
      Search.realTimeCounter(Search.apiObj.totalCount);
    })();
  }, 300),
};
